<!--案例前置学习-->
<template>
  <div class="precasestudy-layer">
    <div class="t-title">训练智能体案例A-前置案例学习</div>
    <div class="container">
      <div class="jindu">
        <div class="xuexijindu">学习进度：</div>
        <div class="progress">
          <el-progress :show-text="true" :stroke-width="10" :percentage="percentage" color="#73E4FD"
                       define-back-color="#E8F4FF"></el-progress>
        </div>
      </div>
      <div class="smtitle" v-if="activeNumber < 5">背景设定</div>
      <div class="beijinsheding" v-if="activeNumber < 5">
        <p><b>你的角色：</b>某银行智能客服实习生</p>
        <p><b>场景：</b>今天上午开始，大量学生反映校园联名卡出现不明扣款，您需要通过智能客服系统处理学生咨询并解决问题。</p>
      </div>
      <precaseCom v-if="activeNumber < 5" ref="precaseCom" :activeNumber="activeNumber" :activeIndex="activeIndex"
                  :qianzhiData="qianzhiData" @onChangeAnswer="onChangeAnswer">
      </precaseCom>

      <!--完成答题展示的内容-->
      <div class="wancheng" v-if="activeNumber == 5">
        <div class="line1">
          <img src="~@imgs/case/Slice 128.png" />
        </div>
        <div class="line2">前置学习完成！</div>
        <div class="line3">
          <p>您已经成功掌握校园卡异常交易处理的基本流程。</p>
          <p>现在可以进入智能客服实训完整功能实操</p>
        </div>
        <div class="line4" @click="complate">
          进入智能客服实训系统
        </div>
        <div class="line5">
          您将可以体验：银行客服全业务场景模拟，银证保岗位陪练、智能客服对话训练等高级功能
        </div>
      </div>
    </div>
    <div class="b-btn" @click="nextTopic" v-show="activeNumber != 5 && isRight">
      继续
    </div>
  </div>
</template>

<script>
import precaseCom from './components/precaseCom.vue'
export default {
  name: '',
  components: { precaseCom },
  props: {},
  data () {
    return {
      activeNumber: 0,
      activeIndex: '',//作答答案
      qianzhiData: [
        {
          id: 0,
          taskname: '任务一：问题识别',
          duihua: `<p>以下是模拟的用户咨询对话：</p>
          <p>学生用户：我的校园卡今天突然被扣了200元，但我没有进行任何消费！</p>
          <p>系统提示：请注意，后台监测显示近期已有10起类似投诉，疑似系统批量扣款错误</p>`,
          zuoda: '作为智能客服，你首先需要：',
          answerA: '确认用户身份信息',
          answerB: '询问扣款的具体时间',
          answerC: '直接道歌并承诺退款',
          yourAnswer: '',
          rightAnswer: 'A'
        },
        {
          id: 1,
          taskname: '任务二：信息收集',
          duihua: `<p>您需要收集以下关键信息来诊断问题：</p>
          <p>·扣款发生的精确时间</p>
          <p>·交易渠道（ATM、POS机、网上银行等）</p>
          <p>·用户近期操作记录</p>`,
          zuoda: '在智能客服中，您会如何设计信息收集流程？',
          answerA: '一次性列出所有问题让用户回答',
          answerB: '分步骤引导用户提供信息，每步一个问题',
          answerC: '只询问最关键的问题，其他通过系统查询',
          yourAnswer: '',
          rightAnswer: 'B'
        },
        {
          id: 2,
          taskname: '任务三：解决方案',
          duihua: `<p>根据收集的信息，您确认这是一起系统批量扣款错误。</p>`,
          zuoda: '您会选择哪种解决方案？',
          answerA: '直接建议用户去柜台处理',
          answerB: '通过智能系统提交差错争议',
          answerC: '转接人工客服',
          yourAnswer: '',
          rightAnswer: 'B'
        },
        {
          id: 3,
          taskname: '任务四：知识库应用',
          duihua: `<p>现在您需要查询银行相关规定来确认处理流程。</p>`,
          zuoda: '您会如何利用智能客服知识库？',
          answerA: '搜索校园卡批量扣款错误',
          answerB: '查询电子银行交易差错处理规范',
          answerC: '查找银保监会对电子银行交易差错的监管要求',
          yourAnswer: '',
          rightAnswer: 'C'
        },
        {
          id: 4,
          taskname: '任务五：处理反馈',
          duihua: `<p>系统已自动生成差错处理工单，编号为CS20230523001。</p>
<p>您需要向用户发送处理结果通知：</p>`,
          zuoda: '选择最合适的回复话术：',
          answerA: '“问题已记录，请等待处理',
          answerB: '已为您提交差错争议，工单号CS20230523001，预计3个工作日内退款',
          answerC: '“抱款给您带来不便，我们会尽快处理”',
          yourAnswer: '',
          rightAnswer: 'B'
        },
      ],
      isRight: false
    }
  },
  computed: {
    percentage () {
      const arr = [0, 20, 40, 60, 80, 100]
      return arr[this.activeNumber]
    },
  },
  watch: {},
  created () { },
  mounted () { },
  methods: {
    onChangeAnswer (data) {
      this.activeIndex = data.activeIndex
      this.isRight = data.isRight
    },
    //继续
    nextTopic () {
      this.activeNumber += 1
      this.activeIndex = ''
      this.isRight = false
    },
    //完成
    complate () {
      this.$router.push({ path: '/case/zhinengkefu', query: {} })
    }
  }
}
</script>

<style scoped lang="less">
.precasestudy-layer {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 0 0;
  background-image: url('~@imgs/case/bg_casedescription.png');
  padding: 0.5rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .t-title {
    width: 100%;
    height: 0.5rem;
    text-align: center;
    font-size: 24px;
  }

  .container {
    width: 10.66rem;
    padding: 0.3rem;
    border-radius: 0.25rem;
    background-color: #fff;

    .jindu {
      display: flex;
      align-content: center;
      width: 100%;

      .xuexijindu {
        width: 7%;
      }

      .progress {
        width: 93%;
      }
    }

    .smtitle {
      margin: 0.1rem 0;
      font-size: 16px;
      color: #4568F7;
    }

    .wancheng {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;

      .line1 {
        width: 2.27rem;
        height: 1.1rem;
        margin: 0.2rem 0;

        img {
          width: 100%;
          height: 100%;
          display: block;
          margin-left: -0.3rem;
        }
      }

      .line2 {
        text-align: center;
        color: #476cf8;
        font-size: 22px;
        margin: 0.2rem 0;
      }

      .line3 {
        text-align: center;
      }

      .line4 {
        width: 1.8rem;
        height: 0.4rem;
        line-height: 0.4rem;
        background: linear-gradient(90deg, #76E8FE 0%, #2187EC 100%);
        border-radius: 9px;
        color: #fff;
        font-weight: bold;
        text-align: center;
        margin-top: 20px;
        cursor: pointer;

        &:hover {
          filter: hue-rotate(20deg) brightness(100%);
        }
      }

      .line5 {
        margin: 0.3rem 0;
      }
    }
  }

  .b-btn {
    width: 1.4rem;
    height: 0.4rem;
    line-height: 0.4rem;
    background: linear-gradient(90deg, #76E8FE 0%, #2187EC 100%);
    border-radius: 9px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    margin-top: 20px;
    cursor: pointer;

    &:hover {
      filter: hue-rotate(20deg) brightness(100%);
    }
  }
}
</style>
